module.exports = __webpack_public_path__ + "static/media/solutionpage-2.48778101.png";